import { createExternalCalendarEvent as _createExternalCalendarEvent } from '@griply/services';
import {
  CalendarEventWriteResult,
  CreateCalendarEventInput,
} from '@griply/types';
import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';
import { reportUnknownCalendarEventError } from './helpers/report-unknown-calendar-event-error';

export const createExternalCalendarEvent = async (
  payload: CreateCalendarEventInput,
): Promise<CalendarEventWriteResult> => {
  try {
    return await _createExternalCalendarEvent({
      functions: getFunctions(),
      httpsCallable,
      payload,
    });
  } catch (error: unknown) {
    reportUnknownCalendarEventError(error, 'external-calendars-create-event');
    throw error;
  }
};
